import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'recommendation.page.title': {
    id: 'recommendation.page.title',
    defaultMessage: 'Recomendaciones | {siteName}',
    description: 'recommendation page title',
  },
  'recommendation.page.heading': {
    id: 'recommendation.page.heading',
    defaultMessage: 'Tenemos algunas recomendaciones para que empieces.',
    description: 'recommendation page heading',
  },
  'recommendation.skip.button': {
    id: 'recommendation.skip.button',
    defaultMessage: 'Omitir por ahora',
    description: 'Skip button text',
  },
  'recommendation.option.trending': {
    id: 'recommendation.option.trending',
    defaultMessage: 'En tendencia',
    description: 'Title for trending products',
  },
  'recommendation.option.popular': {
    id: 'recommendation.option.popular',
    defaultMessage: 'Más populares',
    description: 'Title for popular products',
  },
  'recommendation.option.recommended.for.you': {
    id: 'recommendation.option.recommended.for.you',
    defaultMessage: 'Recomendados para ti',
    description: 'Title for personalized products',
  },
});

export const cardBadgesMessages = defineMessages({
  'recommendation.product-card.pill-text.course': {
    id: 'recommendation.product-card.pill-text.course',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Curso',
  },
  'recommendation.product-card.pill-text.professional-certificate': {
    id: 'recommendation.product-card.pill-text.professional-certificate',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Certificado profesional',
  },
});

export const cardFooterMessages = defineMessages({
  'recommendation.product-card.footer-text.emeritus': {
    id: 'recommendation.product-card.pill-text.emeritus',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Ofrecido en Emeritus',
  },
  'recommendation.product-card.footer-text.shorelight': {
    id: 'recommendation.product-card.pill-text.shorelight',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Ofrecido por Shorelight',
  },
  'recommendation.product-card.footer-text.number-of-courses': {
    id: 'recommendation.product-card.footer-text.number-of-courses',
    description: 'Label in card footer that shows how many courses are in a program',
    defaultMessage: '{length} {label}',
  },
  'recommendation.product-card.footer-text.subscription': {
    id: 'recommendation.product-card.footer-text.subscription',
    description: 'Label in card footer that describes that it is a subscription program',
    defaultMessage: 'Suscripción',
  },
});

export const externalLinkIconMessages = defineMessages({
  'recommendation.product-card.launch-icon.sr-text': {
    id: 'recommendation.product-card.launch-icon.sr-text',
    description: 'Screen reader text for the launch icon on the cards',
    defaultMessage: 'Abre un enlace en una nueva pestaña',
  },
});

export default messages;
